import React from 'react';
import ReactDOM from 'react-dom';
import qs from 'qs';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { Route } from 'react-router-dom';
import { composeWithDevTools } from 'redux-devtools-extension';
import { AppContainer } from 'react-hot-loader';
import createHistory from 'history/createBrowserHistory';
import 'prb-style-library';
import 'prb-style-library/datacenter.scss';
import reducers from 'reducers';
import defaultState from 'config/defaultState';
import { RESET_DATA } from 'config/types';
import { actionUpdateFilter } from 'actions';
import App from 'components/app';
import fetch, { apiUrl } from 'services/fetch';
import withTracker from 'services/withTracker';
import objectFitImages from 'object-fit-images';
import {
  browserSupportsAllFeatures,
  loadScript,
} from './loadPolyfills';

if (browserSupportsAllFeatures()) {
  main();
} else {
  // Use existing hostname for hot reloading, otherwise use from config.
  const host = '8080' === window.location.port ?
    `//${window.location.hostname}:8080` : apiUrl();
  loadScript(`${host}/static/polyfills.bundle.js`, main);
  objectFitImages();
}

function main() {
  // Create a history (using browser history)
  const history = createHistory();

  const initialState = { ...defaultState };

  // See https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store/35641992#35641992
  const rootReducer = (state, action) => {
    if (RESET_DATA === action.type) {
      state = { ...initialState }; // eslint-disable-line no-param-reassign
    }
    return reducers(state, action);
  };

  const middleware = [
    thunk,
    routerMiddleware(history),
  ];

  const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(
      applyMiddleware(...middleware)
    )
  );

  // Pull in initial data
  store.dispatch(fetch.init());

  // Update parent frame when the content of the state changes.
  store.subscribe(() => {
    window.parent.postMessage({ updated: true }, '*');
  });
  // Set the store to a window object... If we need to carry items over from WP
  // window.appJs = { ...window.appJs, store };

  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  if ('undefined' !== typeof query.geos ||
    ('object' === typeof query.geos && 1 === query.geos.length && '' === query.geos[0])
  ) {
    const geos = query.geos.split(',');
    store.dispatch(actionUpdateFilter(geos));
  } else {
    const segments = window.location.pathname.split('/');
    const dataView = 'embed' === segments[1] || 'image-export' === segments[1] ?
      segments[2] : segments[1];
    if ('usdata' === dataView) {
      store.dispatch(actionUpdateFilter(['US']));
    } else if ('international' === dataView) {
      store.dispatch(actionUpdateFilter(['WORLD']));
    }
  }

  const render = (Component) => {
    ReactDOM.render(
      <AppContainer>
        <Provider store={store}>
          {/* ConnectedRouter will use the store from provider automagically */}
          <ConnectedRouter history={history}>
            <Route component={withTracker(Component)} />
          </ConnectedRouter>
        </Provider>
      </AppContainer>,
      document.querySelector('[data-finder]')
    );
  };

  if (module.hot) {
    // Make reducers hot reloadable, see http://stackoverflow.com/questions/34243684/make-redux-reducers-and-other-non-components-hot-loadable
    module.hot.accept('./reducers/', () => {
      store.replaceReducer(require('./reducers/').default); // eslint-disable-line global-require
    });

    module.hot.accept('./components/app', () => {
      const nextApp = require('./components/app').default; // eslint-disable-line global-require
      render(nextApp);
    });
  }

  render(App);
}



// WEBPACK FOOTER //
// ./app/main.js